module.exports = __webpack_public_path__ + "static/img/t13.7e063bff.png";